
import React from 'react'
import PropTypes from 'prop-types'
import {
LOCALE_STRING_OPTIONS,
LOCALE_LANG_OPTIONS
} from '../../../utilities/function/common'

let InvoiceDetails = (props) => {
    const {
        invoice_id = props.invoice_id ? props.invoice_id : 0,
        total = props.total ? props.total : '',
        due = props.due ? props.due : ''
    } = props
  
    return ( // Render
        <div className="of-checkout-invoice-details"> 
            <div className="of-checkout-invoice-details__heading text-font-1-100">
            Invoice Details    
            </div>
            <div className="of-checkout-invoice-details__table lines-border-1-100">
                <div className="of-checkout-invoice-details__row">
                    <div className="of-checkout-invoice-details__column">
                       <div className="of-checkout-invoice-details__text--title text-font-3-100">
                           Invoice Number
                       </div> 
                       <div className="of-checkout-invoice-details__text--subtitle text-font-1-100">
                            #{invoice_id}
                       </div>
                    </div>
                    <div className="of-checkout-invoice-details__column">
                    <div className="of-checkout-invoice-details__text--title text-font-3-100">
                           Total
                       </div> 
                       <div className="of-checkout-invoice-details__text--subtitle text-font-1-100">
                            ${total.toLocaleString(LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS)}
                       </div>
                    </div>
                    <div className="of-checkout-invoice-details__column">
                    <div className="of-checkout-invoice-details__text--title text-font-3-100">
                           Due Date
                       </div> 
                       <div className="of-checkout-invoice-details__text--subtitle text-font-1-100">
                            {due}
                       </div>
                    </div>
                </div>
            </div>
        </div>
    )
  }
  
  InvoiceDetails.propTypes = {
    ref : PropTypes.number,
    total : PropTypes.string,
    due : PropTypes.string
  }

export default InvoiceDetails